import React, { Component } from 'react';
import fire from '../fire';
import { Grid, Form } from 'semantic-ui-react';

class AddLesson extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title:"",
      number:"",
      description: "",
      youtubeId: "",
      assignment: ""
    };
  }

  postLesson = () => {
    const lessonsRef = fire.database().ref('lessons');

    const item = {
      title: this.state.title,
      number: this.state.number,
      description: this.state.description,
      youtubeId: this.state.youtubeId,
      assignment: this.state.assignment
    }

    lessonsRef.push(item);

    this.setState({
      title:"",
      number:"",
      description: "",
      youtubeId: "",
      assignment: ""
    });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ 
      [name]: value
    })
  }

  render() {
    return (
      <Grid>
        <Grid.Column>
          <Form onSubmit={this.postLesson}>
            <Form.Group widths='equal'>
              <Form.Input name="number" type="number" value={this.state.number} placeholder='Enter Lessson number' onChange={this.handleChange}/>
              <Form.Input name="title" type="text" value={this.state.title} placeholder='Enter a Title' onChange={this.handleChange}/>
              <Form.Input name="description" type="text" value={this.state.description} placeholder='Enter a Description' onChange={this.handleChange}/>
              <Form.Input name="youtubeId" type="text" value={this.state.youtubeId} placeholder='Enter the YoutubeId for video' onChange={this.handleChange}/>
              <Form.Input name="assignment" type="text" value={this.state.assignment} placeholder='Assignments for this lesson' onChange={this.handleChange}/>
              <Form.Button content='Submit' />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}
export default AddLesson;
